// Path for twilio blur background access
// If you want to change this path, you need to change in package.json and gitignore too
const BLUR_ASSETS_PATH = "/blurbackground"

const MASK_BLUR_RADIUS = 10

const BLUR_FILTER_RADIUS = 10

const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] = {
  width: { ideal: 1280, max: 1920 },
  height: { ideal: 720, max: 1080 },
  frameRate: 24,
}

const DEFAULT_AUDIO_CONSTRAINTS: MediaStreamConstraints["audio"] = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: false,
}

export { BLUR_ASSETS_PATH, BLUR_FILTER_RADIUS, MASK_BLUR_RADIUS, DEFAULT_VIDEO_CONSTRAINTS, DEFAULT_AUDIO_CONSTRAINTS }
